import {getActionType} from '../util/redux';
import {dataCenterType} from '../action/datacenter';

const initState = {
    generalInfo: null
}


const GeneralInfoSuccess = getActionType(dataCenterType, 'generalInfoSuccess');
const GeneralInfoFail = getActionType(dataCenterType, 'earningListFail');


export default function datacenterReducer(state = initState, action) {
    let {type, payload} = action;
    switch (type) {
        case GeneralInfoSuccess:
            return {
                ...state,
                generalInfo: payload
            }
        case GeneralInfoFail:
            return {
                ...state,
                generalInfo: null
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/datacenter.js